import { easeInOut, motion } from "framer-motion"

export default function FadeInUp({ children, className, delay = 0 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay, ease: 'easeInOut' }}
            viewport={{ amount: 0.3, once: true }}
        >
            {children}
        </motion.div>
    )
}